import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import logo from "../static/images/coreDataImg.png"
// import logo from "../static/images/verdict.png"
// import logo from "../static/images/napino_logo.png"
const PrivateNavHeader = ({ collapsed }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);
  return (
    <>
      <div style={{ padding: collapsed ? 8 : 16, transition: "0.3s" }}>
        <img src="/images/logocd.png" alt="Coredata Logo" style={{ width:isMobile ? "60%" : "83%", height: "50%" }} />
      </div>
      <Divider />
    </>
  )
};

PrivateNavHeader.propTypes = {
  collapsed: PropTypes.bool,
};
PrivateNavHeader.defaultProps = {
  collapsed: false,
};

export default PrivateNavHeader;
